import { ROUTES } from '@/routes/paths';
import type { BestPriceEntry, PriceListGroup } from '@/types/buy';

type PriceListRef = Pick<PriceListGroup, 'address' | 'addressTitle' | 'goods'>;

/** Query прайс-листа: базис и культура (года у закупки нет, решение 2026-11-04). */
function priceListQuery(group: PriceListRef): string {
  return new URLSearchParams({ address: group.address, addressTitle: group.addressTitle, goods: group.goods }).toString();
}

/** Ссылка на деталь группы прайс-листа (/app/buy/group) — единая точка сборки query. */
export function makeGroupUrl(group: PriceListRef): string {
  return `${ROUTES.APP_BUY_GROUP}?${priceListQuery(group)}`;
}

/** Ссылка на правку прайс-листа (/app/buy/edit) — те же параметры, что у детали. */
export function makeEditUrl(group: PriceListRef): string {
  return `${ROUTES.APP_BUY_EDIT}?${priceListQuery(group)}`;
}

export interface OfferLinkContext {
  /** Оффер продажи (из лучшей цены). */
  readonly entry: BestPriceEntry;
  /** Моя строка закупки, под которую покупаем (нет при входе с экрана поиска «Лучшая цена»). */
  readonly fromPurchaseOrderId?: number;
  /** Мой базис (точка выгрузки) — адрес доставки сделки. */
  readonly toAddress: string;
  readonly toAddressTitle: string;
  /** Родительский товар (для ГОСТ-дефолтов приёмки и ссылки «назад» в группу). */
  readonly goods: string;
  /** Выгода относительно моей цены, ₽/т (со знаком) — для показа «к вашей цене» на превью; нет в поиске. */
  readonly advantage?: number;
  /** Моя цена строки, ₽/т: превью сравнивает с ней цену продавца («на N ₽/т ниже вашей цены M»); нет в поиске. */
  readonly myPrice?: number;
}

/** Ссылка на превью оффера продажи (/app/buy/offer) со всем контекстом покупки в query. */
export function makeOfferUrl(context: OfferLinkContext): string {
  const qs = new URLSearchParams({
    saleOrderId: String(context.entry.saleOrderId),
    saleOrderVersion: String(context.entry.saleOrderVersion),
    toAddress: context.toAddress,
    toAddressTitle: context.toAddressTitle,
    goods: context.goods,
  });
  if (context.fromPurchaseOrderId != null) {
    qs.set('fromPurchaseOrderId', String(context.fromPurchaseOrderId));
  }
  if (context.advantage != null) {
    qs.set('advantage', String(context.advantage));
  }
  if (context.myPrice != null) {
    qs.set('myPrice', String(context.myPrice));
  }
  return `${ROUTES.APP_BUY_OFFER}?${qs.toString()}`;
}
